import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {MemberTpiccvData} from 'src/app/models/member-tpiccv-data';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-tpiccv-dialog',
  templateUrl: './member-tpiccv-dialog.component.html',
  styleUrls: [ './member-tpiccv-dialog.component.scss' ]
})
export class MemberTpiccvDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public form: FormGroup;
  public isEdit: boolean

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberTpiccvDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MemberTpiccvData
  ) {

    if (this.data.id == '0') {
      this.isEdit = false
    } else {
      this.isEdit = true
    }
    this.form = this.createTpiccvForm(this.data)
  }

  ngOnInit () {

  }

  createTpiccvForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      text: new FormControl(data.text, [ Validators.required ]),
      date: new FormControl(data.date, [ Validators.required ]),
      member_id: new FormControl(data.member_id),
      member_name: new FormControl(data.member_name)
    });
    return form
  }



}
